import { createSlice,createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";
import { BaseAPI } from "src/providers/base-api";

export const getUsers: any = createAsyncThunk('getUsers', async() => {
    return BaseAPI.getUserList().then(res=>{
        return res.data
    })
})



const usersSlice = createSlice({
    name : 'users',
    initialState : {
        users : [],
        loading: false
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getUsers.pending, (state) => {
                state.loading = true;
            })
            .addCase(getUsers.fulfilled, (state, action) => {
                state.loading = false;
                state.users = action.payload;
            })
            .addCase(getUsers.rejected, (state) => {
                state.loading = false;
            });
    },
})

export default usersSlice.reducer;